import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async publicistas(payload) {
    const response = await api.post(API_URL + "publicistas", payload ?? {});
    return response.data;
  },

  async publicistaTipsters(payload) {
    const response = await api.post(API_URL + "publicistaTipsters", payload);
    return response.data;
  },

  async guardaPublicistaTipsters(payload) {
    const response = await api.post(API_URL + "guardaPublicistaTipsters", payload);
    return response.data;
  },
};
